/*
 *
 * Notifier constants
 *
 */

const prefix = 'ui/containers/Notifier';

export const ENQUEUE_SNACKBAR = `${prefix}/ENQUEUE_SNACKBAR`;
export const CLOSE_SNACKBAR = `${prefix}/CLOSE_SNACKBAR`;
export const REMOVE_SNACKBAR = `${prefix}/REMOVE_SNACKBAR`;
